import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileUiService {
  isMobile = new BehaviorSubject<boolean>(false);
  constructor() { }
}
